import React, { Component } from 'react';
import { Container } from 'reactstrap';
import { NavMenu } from './NavMenu';
import { Modal1 } from './Modal1';


export class Layout extends Component {
    static displayName = Layout.name;

    constructor(props) {
        super(props);
        this.state = {

            showModal: "",
            closeModal: false,
            copyrightYear: new Date().getFullYear()
        };


        this.displayModal = this.displayModal.bind(this);
        this.handleClose = this.handleClose.bind(this);
    }

    displayModal(proj, event) {
        event.preventDefault();

        this.setState({ showModal: proj, closeModal: false });
    }

    handleClose() {

        this.setState({ showModal: "", closeModal: true });
    }

    render() {
        const showModal = this.state.showModal;
        const closeModal = this.state.closeModal;

        return (
            <div>

                <section id="headerSec">
                    <NavMenu />
                    <div className="social-nav">
                        <ul className="list-inline social-buttons">
                            <li className="list-inline-item">
                                <a href="http://blog.mycocreations.com">

                                    <i className="fab fa-wordpress"></i>

                                </a>
                            </li>
                            <li className="list-inline-item">
                                <a href="http://facebook.com/mycocreations">

                                    <i className="fab fa-facebook-f"></i>

                                </a>
                            </li>
                            <li className="list-inline-item">
                                <a href="http://www.twitter.com/mycocreations">

                                    <i className="fab fa-twitter"></i>

                                </a>
                            </li>
                            <li className="list-inline-item">
                                <a href="http://www.pinterest.com/mycocreations">

                                    <i className="fab fa-pinterest"></i>

                                </a>
                            </li>
                            <li className="list-inline-item">
                                <a href="https://instagram.com/mycocreations">

                                    <i className="fab fa-instagram"></i>

                                </a>
                            </li>
                            <li className="list-inline-item">
                                <a href="https://stackoverflow.com/users/7422426/technificent-consulting">

                                    <i className="fab fa-stack-overflow"></i>
                                </a>

                            </li>
                        </ul>
                    </div>
                    {/*  Header  */}

                    <header id="home" className="masthead">
                        <div className="container">
                            <div id="banners" className="row">
                                <div className="banner1 col-md-6" >
                                    <img alt="BookCover" src="../img/portfolio/CoverPicture.png" />
                                </div>
                                <div className="banner2 col-md-6" >
                                    <img alt="FoodieGallery" src="../img/portfolio/FoodieGallery.png" />
                                </div>
                                <div className="btnCallout">
                                    <a className="btn btn-primary btn-xl text-uppercase js-scroll-trigger"
                                        target="_blank" rel="noopener noreferrer"
                                        href="http://boutique.mycocreations.com/books/227-recipe-book-mycos-kitchen-adventures-.html">Now Available</a>
                                </div>
                            </div>
                            <div id="ssitebanners" className="row">
                                <div className="col-md-4"><a href="http://boutique.mycocreations.com"
                                    target="_blank" rel="noopener noreferrer"><div className="ssite1"></div></a></div>
                                <div className="col-md-4"><a href="http://roots-r-us.com"
                                    target="_blank" rel="noopener noreferrer"><div className="ssite2" ></div></a></div>
                                <div className="col-md-4"><a href="http://shop.mycocreations.com"
                                    target="_blank" rel="noopener noreferrer"><div className="ssite3" ></div></a></div>
                            </div>
                        </div>
                    </header>

                </section>
                <section>
                    <Container>
                        {this.props.children}
                    </Container>
                </section>
                <div id="miniMyCo" className="col-md-12" style={{ width: 'max-content', top: '79%', position: 'fixed', right: '-15px' }}>
                    <a href="#headerSec" ><img alt="ToTop" src="../img/logos/MiniMyCo.png" height="auto" width="auto" style={{ paddingBottom: '0px' }} /><p style={{ paddingLeft: '17px', marginTop: '-5px' }}>To Top</p></a>
                </div>
                {/* Footer */}

                <footer className="footer">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-md-6">
                                <span className="copyright">Copyright &copy; Technificent Consulting { this.copyrightYear}</span>
                            </div>
                            <div className="col-md-6">
                                <ul className="list-inline quicklinks">
                                    <li className="list-inline-item">
                                        <a href="#ppolicy" onClick={(event) => this.displayModal("Modal1", event)}>Privacy Policy</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <Modal1 show={!closeModal && showModal === "Modal1" ? true : false} handleClose={this.handleClose} />

                </footer>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/Layout.js